// Kalman Claudsky: help instructions for the Tanach Family Tree (YuchsinTreeViewer).
// Covers 3D navigation, person selection, toolbar controls, ancestor/descendant highlighting
// with animation, the Find Relation popup, and window controls. Bilingual (Hebrew / English).

import React, { Component } from 'react';

class YuchsinTreeViewer_Instructions extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  getTranslatedContent(langCode) {
    if (!["he", "en"].includes(langCode)) {
      langCode = "en";
    }
    var retVal;
    if (langCode === "he") {
      retVal = <>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><span lang="HE" style={{fontSize:'14.0pt', fontFamily:'"Arial",sans-serif'}}>אילן יוחסין תנ"כי</span></b>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>מטרה</span></u></b>
        </p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
          המחשה תלת-ממדית אינטראקטיבית של קשרי היוחסין בין הדמויות והמשפחות המוזכרות בתנ"ך.
          הצופה מאפשר לחקור אבות וצאצאים, לאתר את נתיב הקשר בין כל שני אנשים מקראיים,
          ולעבור ישירות מאדם נבחר לופיעותיו בתנ"ך.
          </span>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>השקה</span></u></b>
        </p>

        <p className="MsoListParagraphCxSpFirst" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>לחץ על האייקון <b>אילן יוחסין תנ"כי</b> בתפריט הראשי כדי לפתוח את הצופה</span>
        </p>
        <p className="MsoListParagraphCxSpLast" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>מצב <b>מסך מלא</b> מומלץ לחוויה הטובה ביותר — ראה כפתורי בקרת חלון להלן</span>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>ניווט בעץ התלת-ממדי</span></u></b>
        </p>

        <p className="MsoListParagraphCxSpFirst" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}><b>גרור</b> כדי לסובב את התצוגה בכל כיוון</span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}><b>גלגל העכבר</b> מגדיל ומקטין את התצוגה</span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}><b>לחיצה על צומת</b> (כדור) בעץ בוחרת את האדם — שמו יופיע בתיבת הבחירה בראש החלון</span>
        </p>
        <p className="MsoListParagraphCxSpLast" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>ריחוף מעל צומת מציג כרטיס קצר עם פרטי האדם</span>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>בחירת אדם</span></u></b>
        </p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
          ניתן לבחור אדם בשתי דרכים: לחיצה על הצומת שלו בעץ, או שימוש בתיבת הבחירה בראש החלון —
          הקלד חלק מהשם כדי לסנן את הרשימה ולאחר מכן לחץ על השם הרצוי.
          לאחר הבחירה, פקדים נוספים יהפכו לזמינים בסרגל הכלים.
          </span>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>כפתורי בקרת חלון</span></u></b>
        </p>

        <table className="MsoTableGrid" border={0} cellSpacing={0} cellPadding={0} style={{borderCollapse:'collapse', border:'none', direction:'rtl'}}>
          <tbody>
          <tr style={{height:'.2in'}}>
            <td width={30} valign="top" style={{width:'22pt', padding:'2pt 4pt', height:'.2in'}}>
              <p className="MsoNormal"><img width={22} height={22} src="helpDialogImages/image069.png" /></p>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>סגור את חלון הצופה</span></p>
            </td>
          </tr>
          <tr style={{height:'.2in'}}>
            <td width={30} valign="top" style={{width:'22pt', padding:'2pt 4pt', height:'.2in'}}>
              <p className="MsoNormal"><img width={22} height={22} src="helpDialogImages/image070.png" /></p>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>הרחב למסך מלא</span></p>
            </td>
          </tr>
          <tr style={{height:'.2in'}}>
            <td width={30} valign="top" style={{width:'22pt', padding:'2pt 4pt', height:'.2in'}}>
              <p className="MsoNormal"><img width={22} height={22} src="helpDialogImages/image071.png" /></p>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>שנה גודל לתצוגת מסך מפוצל</span></p>
            </td>
          </tr>
          </tbody>
        </table>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>סרגל הכלים</span></u></b>
        </p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
          לאחר בחירת אדם, הפקדים הבאים זמינים בסרגל הכלים בראש החלון:
          </span>
        </p>

        <table className="MsoTableGrid" border={0} cellSpacing={0} cellPadding={0} style={{borderCollapse:'collapse', border:'none', direction:'rtl'}}>
          <tbody>
          <tr style={{height:'.25in'}}>
            <td width={50} valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={24} height={24} src="helpDialogImages/image001.jpg" style={{visibility:'hidden'}} />
              <span style={{fontSize:'12pt'}}>🔍</span>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>חפש בתנ"ך</span></b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}> – חיפוש האדם הנבחר בתנ"ך</span></p>
            </td>
          </tr>
          <tr style={{height:'.25in'}}>
            <td valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={28} height={28} src="helpDialogImages/yuchsin_ancestorsOff.jpg" />
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>הבלט אבות</span></b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}> – הבלט / בטל הבלטת כל אבות האדם הנבחר בעץ</span></p>
            </td>
          </tr>
          <tr style={{height:'.25in'}}>
            <td valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={28} height={28} src="helpDialogImages/yuchsin_descendantsOff.jpg" />
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>הבלט צאצאים</span></b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}> – הבלט / בטל הבלטת כל צאצאי האדם הנבחר בעץ</span></p>
            </td>
          </tr>
          <tr style={{height:'.25in'}}>
            <td valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={39} height={15} src="helpDialogImages/yuchsin_nodeConnectOrange.jpg" />
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}><b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>חפש ליחס</span></b><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}> – פתח את חלון "חפש ליחס" (ראה להלן)</span></p>
            </td>
          </tr>
          </tbody>
        </table>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>הבלטת אבות וצאצאים</span></u></b>
        </p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
          לאחר לחיצה על אחד מכפתורי ההבלטה, ניתן ללחוץ על אייקון ה<b>הגדרות</b> (⚙) כדי לפתוח חלון פקדים עם האפשרויות הבאות:
          </span>
        </p>

        <p className="MsoListParagraphCxSpFirst" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}><b>דורות להבליט</b> – מחוון הגובל את מספר הדורות המרבי שיוצגו בהבלטה</span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
            <img width={28} height={28} src="helpDialogImages/yuchsin_allGenerationsOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            <img width={28} height={28} src="helpDialogImages/yuchsin_oneGenerationOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            &nbsp;<b>כל הדורות</b> לעומת <b>דור אחד בכל פעם</b> – שולט באופן הצגת ההבלטה באנימציה
          </span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
            <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromStartOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromEndOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            &nbsp;<b>חזור</b> / <b>הפוך בסוף</b> – שליטה בהתנהגות האנימציה לאחר שמגיעה לסיומה
          </span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
            <img width={28} height={28} src="helpDialogImages/yuchsin_play.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            <img width={28} height={28} src="helpDialogImages/yuchsin_pause.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            &nbsp;<b>הפעל / עצור</b> אנימציה של ההבלטה
          </span>
        </p>
        <p className="MsoListParagraphCxSpLast" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>האנימציה נחווית בצורה הטובה ביותר במסך מלא</span>
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <b><u><span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>חיפוש יחס בין שני אנשים</span></u></b>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}> (חפש ליחס)</span>
        </p>

        <p className="MsoNormal" dir="RTL" style={{textAlign:'right', direction:'rtl'}}>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
          לאחר בחירת אדם ראשון מהעץ, לחץ על כפתור
          &nbsp;<img width={39} height={15} src="helpDialogImages/yuchsin_nodeConnectOrange.jpg" style={{verticalAlign:'middle'}} />&nbsp;
          כדי לפתוח את חלון "חפש ליחס":
          </span>
        </p>

        <p className="MsoListParagraphCxSpFirst" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>בחר אדם שני מהרשימה הנפתחת <b>בן אדם ליחס</b> — הקלד כדי לסנן, ולאחר מכן לחץ על שם</span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>נתיב היחס הגנאולוגי בין שני האנשים יוצג בתיבת הטקסט</span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>הטקסט ניתן לבחירה ולהעתקה — לחץ בתוך האזור ולאחר מכן השתמש ב-<b>Ctrl+A</b> לבחור הכל, ו-<b>Ctrl+C</b> להעתיק</span>
        </p>
        <p className="MsoListParagraphCxSpMiddle" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>
            פקדי האנימציה בתחתית החלון —
            <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromStartOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromEndOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            <img width={28} height={28} src="helpDialogImages/yuchsin_play.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
            — מאפשרים להציג את הנתיב שלב אחר שלב
          </span>
        </p>
        <p className="MsoListParagraphCxSpLast" dir="RTL" style={{marginRight:'.5in', textIndent:'-.25in', textAlign:'right', direction:'rtl'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <span lang="HE" style={{fontFamily:'"Arial",sans-serif'}}>ניתן לגרור את החלון "חפש ליחס" למיקום נוח</span>
        </p>

      </>;
    } else if (langCode === "en") {
      retVal = <>

        <p className="MsoNormal"><b><span style={{fontSize:'14.0pt'}}>Tanach Family Tree</span></b></p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Goal</u></b></p>

        <p className="MsoNormal">An interactive 3D visualization of the genealogical relationships between
        the people and families mentioned in Tanach. The viewer lets you explore ancestors and descendants,
        trace the relationship path between any two biblical figures, and jump directly from a selected
        person to their Tanach appearances.</p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Launching</u></b></p>

        <p className="MsoListParagraphCxSpFirst" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          Click the <b>Tanach Family Tree</b> icon in the Main Menu to open the viewer.
        </p>
        <p className="MsoListParagraphCxSpLast" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <b>Full-screen</b> mode is recommended for the best experience — see window controls below.
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Navigating the 3D tree</u></b></p>

        <p className="MsoListParagraphCxSpFirst" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <b>Drag</b> to rotate the view in any direction.
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <b>Mouse wheel</b> zooms in and out.
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <b>Click on any node</b> (sphere) to select that person — their name will appear in the selection box at the top of the window.
        </p>
        <p className="MsoListParagraphCxSpLast" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <b>Hover</b> over a node to see a brief card with information about that person.
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Selecting a person</u></b></p>

        <p className="MsoNormal">A person can be selected two ways: by clicking their node in the 3D tree,
        or by using the name selection box at the top of the window — type any part of a name to filter
        the list, then click the desired name. Once a person is selected, additional toolbar controls become
        available.</p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Window controls</u></b></p>

        <table className="MsoTableGrid" border={0} cellSpacing={0} cellPadding={0} style={{borderCollapse:'collapse', border:'none'}}>
          <tbody>
          <tr style={{height:'.2in'}}>
            <td width={30} valign="top" style={{width:'22pt', padding:'2pt 4pt', height:'.2in'}}>
              <p className="MsoNormal"><img width={22} height={22} src="helpDialogImages/image069.png" /></p>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal">Closes the viewer window</p>
            </td>
          </tr>
          <tr style={{height:'.2in'}}>
            <td width={30} valign="top" style={{width:'22pt', padding:'2pt 4pt', height:'.2in'}}>
              <p className="MsoNormal"><img width={22} height={22} src="helpDialogImages/image070.png" /></p>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal">Expands to full-screen view</p>
            </td>
          </tr>
          <tr style={{height:'.2in'}}>
            <td width={30} valign="top" style={{width:'22pt', padding:'2pt 4pt', height:'.2in'}}>
              <p className="MsoNormal"><img width={22} height={22} src="helpDialogImages/image071.png" /></p>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal">Resizes to split-screen view (fills the area below the search bar)</p>
            </td>
          </tr>
          </tbody>
        </table>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Toolbar controls</u></b></p>

        <p className="MsoNormal">After selecting a person, the following controls are available in the toolbar at the top of the window:</p>

        <table className="MsoTableGrid" border={0} cellSpacing={0} cellPadding={0} style={{borderCollapse:'collapse', border:'none'}}>
          <tbody>
          <tr style={{height:'.25in'}}>
            <td width={50} valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <span style={{fontSize:'14pt'}}>🔍</span>
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal"><b>Search in Tanach</b> — searches Tanach for the currently selected person</p>
            </td>
          </tr>
          <tr style={{height:'.25in'}}>
            <td valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={28} height={28} src="helpDialogImages/yuchsin_ancestorsOff.jpg" />
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal"><b>Highlight ancestors</b> — highlights / unhighlights all ancestors of the selected person in the tree</p>
            </td>
          </tr>
          <tr style={{height:'.25in'}}>
            <td valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={28} height={28} src="helpDialogImages/yuchsin_descendantsOff.jpg" />
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal"><b>Highlight descendants</b> — highlights / unhighlights all descendants of the selected person in the tree</p>
            </td>
          </tr>
          <tr style={{height:'.25in'}}>
            <td valign="middle" style={{padding:'2pt 4pt', textAlign:'center'}}>
              <img width={39} height={15} src="helpDialogImages/yuchsin_nodeConnectOrange.jpg" />
            </td>
            <td valign="middle" style={{padding:'2pt 4pt'}}>
              <p className="MsoNormal"><b>Find relation</b> — opens the Find Relation popup (see below)</p>
            </td>
          </tr>
          </tbody>
        </table>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Highlighting ancestors and descendants</u></b></p>

        <p className="MsoNormal">After clicking an ancestors or descendants highlight button, click the <b>Settings</b> icon (⚙) to open a control panel with the following options:</p>

        <p className="MsoListParagraphCxSpFirst" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <b>Generations to highlight</b> — slider that limits the maximum number of generations shown in the highlight
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <img width={28} height={28} src="helpDialogImages/yuchsin_allGenerationsOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          <img width={28} height={28} src="helpDialogImages/yuchsin_oneGenerationOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          &nbsp;<b>All generations</b> vs <b>one generation at a time</b> — controls how the highlight is shown during animation
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromStartOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromEndOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          &nbsp;<b>Repeat at end</b> / <b>Reverse at end</b> — controls animation behavior when it reaches the last generation
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          <img width={28} height={28} src="helpDialogImages/yuchsin_play.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          <img width={28} height={28} src="helpDialogImages/yuchsin_pause.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          &nbsp;<b>Play / Pause</b> the generation highlighting animation
        </p>
        <p className="MsoListParagraphCxSpLast" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          Animation is best experienced in full-screen mode
        </p>

        <p className="MsoNormal">&nbsp;</p>

        <p className="MsoNormal"><b><u>Finding the relation between two people</u></b></p>

        <p className="MsoNormal">After selecting a first person from the tree, click the
        &nbsp;<img width={39} height={15} src="helpDialogImages/yuchsin_nodeConnectOrange.jpg" style={{verticalAlign:'middle'}} />&nbsp;
        button to open the Find Relation popup:</p>

        <p className="MsoListParagraphCxSpFirst" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          Select a second person from the <b>Person to relate</b> dropdown — type to filter the list, then click a name.
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          The genealogical relationship path between the two people is displayed in the text area.
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          The path text is selectable and copyable — click inside the area, then use <b>Ctrl+A</b> to select all and <b>Ctrl+C</b> to copy.
        </p>
        <p className="MsoListParagraphCxSpMiddle" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          The animation controls at the bottom of the popup —&nbsp;
          <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromStartOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          <img width={28} height={28} src="helpDialogImages/yuchsin_repeatFromEndOff.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          <img width={28} height={28} src="helpDialogImages/yuchsin_play.jpg" style={{verticalAlign:'middle', margin:'0 3px'}} />
          — let you animate the path step by step through the tree.
        </p>
        <p className="MsoListParagraphCxSpLast" style={{textIndent:'-.25in'}}>
          <span style={{fontFamily:'Symbol'}}>·<span style={{font:'7.0pt "Times New Roman"'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span>
          The Find Relation popup can be dragged to a convenient position within the screen.
        </p>

      </>;
    }
    return retVal;
  }

  render() {
    return <>
      {this.getTranslatedContent(this.props.langCode)}
    </>
  }
}

export default YuchsinTreeViewer_Instructions;
